var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLock = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.5 6C7.5 3.51472 9.51472 1.5 12 1.5C14.4853 1.5 16.5 3.51472 16.5 6V10.5H7.5V6ZM18 10.5V6C18 2.68629 15.3137 0 12 0C8.68629 0 6 2.68629 6 6V10.5H4.25C2.73122 10.5 1.5 11.7312 1.5 13.25V21.25C1.5 22.7688 2.73122 24 4.25 24H19.75C21.2688 24 22.5 22.7688 22.5 21.25V13.25C22.5 11.7312 21.2688 10.5 19.75 10.5H18ZM16.5 12H18H19.75C20.4404 12 21 12.5596 21 13.25V21.25C21 21.9404 20.4404 22.5 19.75 22.5H4.25C3.55964 22.5 3 21.9404 3 21.25V13.25C3 12.5596 3.55964 12 4.25 12H16.5ZM12 15C11.1716 15 10.5 15.6716 10.5 16.5V18C10.5 18.8284 11.1716 19.5 12 19.5C12.8284 19.5 13.5 18.8284 13.5 18V16.5C13.5 15.6716 12.8284 15 12 15Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgLock);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lock.8f1693eac89af88348c1610789de02d1.svg";